import { create } from 'zustand';

const useBetsStore = create((set, get) => ({
  selections: [],
  stake: 10,
  isOpen: false,
  addSelection: (selection) => set((state) => {
    const exists = state.selections.find((s) => s.market_id === selection.market_id);
    let newSelections;
    if (exists) {
      if (exists.selection === selection.selection) {
        newSelections = state.selections.filter((s) => s.market_id !== selection.market_id);
      } else {
        newSelections = state.selections.map((s) => (s.market_id === selection.market_id ? selection : s));
      }
    } else {
      newSelections = [...state.selections, selection];
    }
    return { selections: newSelections, isOpen: newSelections.length > 0 };
  }),
  removeSelection: (market_id) => set((state) => ({
    selections: state.selections.filter((s) => s.market_id !== market_id),
    isOpen: state.selections.filter((s) => s.market_id !== market_id).length > 0,
  })),
  setStake: (stake) => set({ stake }),
  clear: () => set({ selections: [], stake: 10, isOpen: false }),
  getPotentialReturn: () => {
    const { selections, stake } = get();
    if (selections.length === 0) return 0;
    const odds = selections.reduce((acc, s) => acc * s.odds, 1);
    return parseFloat((stake * odds).toFixed(2));
  },
}));

export default useBetsStore;
